import React from "react"
import { AppFunctionComponent } from "../../types"
import {
  BuilderHero,
  HeroBuilder,
  HeroBuilderType,
  SliderBuilder,
} from "../../types"
import HeroResolver from "../hero/hero.resolver"
import SliderResolver from "../slider/slider.resolver"

const HeroSectionResolver: AppFunctionComponent<BuilderHero> = (
  hero: BuilderHero
) => {
  switch (hero.internal?.type) {
    case HeroBuilderType.Hero:
      return <HeroResolver {...(hero as HeroBuilder)} />
    case HeroBuilderType.Slider:
      return <SliderResolver {...(hero as SliderBuilder)} />
    default:
      return null
  }
}

export default HeroSectionResolver
